import React from 'react';
import { AuthTemplate } from '../../../components/Auth/AuthTemplate';
import { LoginForm } from '../../../components/Auth/LoginForm';

const Login = () => {
  return (
    <AuthTemplate
      footer={{
        title: 'New to Lucky Services?',
        buttonText: 'Create an account',
        buttonUrl: '/signup',
      }}
    >
      <LoginForm />
    </AuthTemplate>
  );
};

export default Login;
